import { z } from 'zod';
import { SanityDocumentSchema } from '../sanity';
import { ComponentType } from '../../types';
import { NewsShapeUnion } from '../entities/NewsTag';
import { LinkFieldsSchema } from '../shared/Link';

export const ShapeLinkSchema = SanityDocumentSchema.extend({
  _type: z.literal(ComponentType.ShapeLink),
  eyebrowText: z.string().nullish(),
  link: LinkFieldsSchema.required(),
  shape: NewsShapeUnion.nullable().transform((x) => x ?? 'oval')
});

export type ShapeLink = z.infer<typeof ShapeLinkSchema>;
